export function toSentenceCase(str: string): string {
  if (!str) return "";

  let normalized = str.trim().replace(/\s+/g, " ").toLowerCase();

  normalized = normalized.charAt(0).toUpperCase() + normalized.slice(1);

  normalized = normalized.replace(/([.?!]\s*)([a-z])/g, (_, punct, char) => {
    return punct + char.toUpperCase();
  });

  return normalized;
}